import { getBrText } from '@helpers/helper.rendering'
import React from 'react'
import { RealEstateDataPageComponentData } from 'types'

const Compromiso_1 = ({ items }: RealEstateDataPageComponentData) => {
  return (
    <section className="about-compromiso-b p-y-config">
      <div className="container-fluid">
        <div className="row items">
          <div className=" col-12 d-lg-flex align-items-center px-lg-0 px-3 mb-lg-0 animate__animated animate__left">
            <h1 className="me-lg-5">{items![0].title}</h1>
            <p className="float-right">
              {getBrText(items![0].paragraph!).map((element) => (
                <>
                  {element}
                  <br className="d-none d-lg-block" />
                </>
              ))}
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid half-fluid-about">
        <div className="row">
          <div className="col-lg-12 col-11 offset-1 offset-lg-0 d-lg-flex align-items-center px-0 mb-lg-0 animate__animated animate__right">
            <p className="d-none d-lg-block">
              {getBrText(items![1].paragraph!).map((element) => (
                <>
                  {element}
                  <br className="d-none d-lg-block" />
                </>
              ))}
            </p>
            <h1 className="justify-content-left">{items![1].title}</h1>
            <p className="float-right d-lg-none d-block">
              {getBrText(items![1].paragraph!).map((element) => (
                <>
                  {element}
                  <br className="d-none d-lg-block" />
                </>
              ))}
            </p>
          </div>
          {/* <CIRCLE_LOOP className="image-rotate" /> */}
        </div>
      </div>
      <div className="row">
        <div className="col-12 d-flex align-items-lg-center px-lg-0 px-1 p mb-lg-3 animate__animated animate__left">
          <h1 className="me-lg-5">{items![2].title}</h1>
          <p className="mb-0">
            {getBrText(items![2].paragraph!).map((element) => (
              <>
                {element}
                <br className="d-none d-lg-block" />
              </>
            ))}
          </p>
        </div>
      </div>
    </section>
  )
}

export default Compromiso_1
